import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../hooks/useAuth';
import { useForm } from 'react-hook-form';
import { DevTool } from '@hookform/devtools'
// Config
import {

  IOD_BASE_URL

} from '../config';
// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';

// Hook

// Image
import Injuries from '../images/Injuries.png';

let renderCount = 0

const NewInjury = () => {

  const auth = useAuth();
  const { id } = useParams()
  console.log(id)
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "./";

  const form = useForm()
  const { register, control, handleSubmit, formState } = form
  const { errors } = formState

  const [errMessage, setErrMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken

  console.log(" from = " + from)

  const onSubmit = async data => {

    console.log("Form Submitted", data)

    const transformedData = {
      ...data,

      employee: id,
      date: new Date(),  
      place: data.place==="yes" ? "Waterkloof addres" : "Other addres",  
      accidentdate: data.accidentdate==="yes"? new Date(): new Date()-1,
      duties: data.duties==="yes" ? "General employee duties" : "Other duties"
    };

    console.log(transformedData)

    console.log(IOD_BASE_URL)  
    try {
      const response =  await axios.post(`${IOD_BASE_URL}`,
        JSON.stringify({data:transformedData}),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer '+accessToken

          }
        }
      );

      navigate(from, {replace: true});

    } catch (error) {

      if(!error.response){
        setErrMessage("No server response")
      }else if (error.response?.status === 400){
        setErrMessage("Missing data")
      }else if (error.response?.status === 500){

        setErrMessage(error.response?.data.msg.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }


  }
  renderCount++


  return (
    <>
      <Header username={username} role={access} destination={from}></Header>
      <h1>RenderCount {renderCount / 2}</h1>


      <section>

        <p >
          {errMessage}
        </p>
        <img
          src={Injuries}
          alt={"Injury"}
          className="injuryAvatar"

        />
      </section>
      <form onSubmit={handleSubmit(onSubmit)} noValidate className="FormClass">


        <div className='Lineitem'>
          <label>What happened?</label>
          <input className="inputsize" type={"text"} {...register('accidentdescription', {
            required: 'This is required'
          })} />
          <p className='error'>{errors.accidentdescription?.message}</p>
        </div>

        <div className='Lineitem'>
          <label>Describe Injuries</label>
          <input className="inputsize" type={"text"} {...register('injurydescription', {
            required: 'This is required'
          })} />
          <p className='error'>{errors.injurydescription?.message}</p>
        </div>

        <div className='Lineitem'>
          <label>Was the injury at the workplace address?</label>
          <div>
          <label>
            Yes
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="yes"
              defaultChecked
              {...register('place')} />
          </label>
          <label>
            No
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="no"
              
              {...register('place')} />
          </label>
          </div>
          <p className='error'>{errors.place?.message}</p>
        </div>

        <div className='Lineitem'>
          <label>Did the incident happen now?</label>
          <div>
          <label>
            Yes
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="yes"
              defaultChecked
              {...register('accidentdate')} />
          </label>
          <label>
            No
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="no"
              
              {...register('accidentdate')} />
          </label>
          </div>
          <p className='error'>{errors.place?.message}</p>
        </div>

        <div className='Lineitem'>
          <label>Was the employee performing normal duties?</label>
          <div>
          <label>
            Yes
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="yes"
              defaultChecked
              {...register('duties')} />
          </label>
          <label>
            No
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="no"
              
              {...register('duties')} />
          </label>
          </div>
          <p className='error'>{errors.place?.message}</p>
        </div>

        <div className='Lineitem'>
          <label>Was it a traffic accident on a public road?</label>
          <div>
          <label>
            Yes
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="yes"
              
              {...register('traffic')} />
          </label>
          <label>
            No
            <input
              className="inputsize"
              type="radio"
              name="place"
              value="no"
              defaultChecked
              {...register('traffic')} />
          </label>
          </div>
          <p className='error'>{errors.place?.message}</p>
        </div>



        <button>Submit</button>
      </form>

      <DevTool control={control} />

    </>
  )
};

export default NewInjury;
